import { render, staticRenderFns } from "./company-location-features-card.vue?vue&type=template&id=55129b10&scoped=true&"
import script from "./company-location-features-card.vue?vue&type=script&lang=js&"
export * from "./company-location-features-card.vue?vue&type=script&lang=js&"
import style0 from "./company-location-features-card.vue?vue&type=style&index=0&id=55129b10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55129b10",
  null
  
)

export default component.exports